import React, { useEffect } from 'react'
import { useCountdown } from '../utils/useCountdown'
import { TOAST_DURATION } from '../constants/Constants'

function Clock({ closeToast = () => {} }) {
    const targetTime = TOAST_DURATION / 1000
    const { seconds } = useCountdown(targetTime)

    useEffect(() => {
        if (seconds < 0) closeToast()
    }, [seconds])

    return <>{seconds}</>
}

export default Clock
